// extracted by mini-css-extract-plugin
module.exports = {"scrollable":"ScrollView_scrollable__IlSbG","justifyCenter":"ScrollView_justifyCenter__C_clU"};